import {
  FETCH_MANAGER_HOURANALYTICS_REQUEST,
  FETCH_MANAGER_HOURANALYTICS_SUCCESS,
  FETCH_MANAGER_HOURANALYTICS_FAILURE
} from "../../Constants";

import { managerTimesheet } from "../../Api/managerTimesheet";

function requestFetchHourAnalytics() {
  return {
    type: FETCH_MANAGER_HOURANALYTICS_REQUEST,
    isFetching: true
  };
}

function fetchHourAnalyticsSuccess(data) {
  return {
    type: FETCH_MANAGER_HOURANALYTICS_SUCCESS,
    isFetching: false,
    data
  };
}

function fetchHourAnalyticsError(errorMessage) {
  return {
    type: FETCH_MANAGER_HOURANALYTICS_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const fetchManagerHourAnalytics = payload => (dispatch, getState) => {
  dispatch(requestFetchHourAnalytics());
  managerTimesheet
    .fecthHourAnalytics(payload)
    .then(res => {
      dispatch(fetchHourAnalyticsSuccess(res));
    })
    .catch(err => dispatch(fetchHourAnalyticsError(err)));
};
